import React from 'react'
import { Box, MenuItem, Select, Typography } from '@mui/material'
import useStyles from './styles'
import useGlobalStyles from '../../utils/globalStyles'

// MUI's Select draws its own outline and inner padding on top of
// globalClasses.input; drop both so it matches the plain inputs exactly.
export const selectMatchInputSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '& .MuiSelect-select': {
    padding: '0 24px 0 0 !important',
    display: 'flex',
    alignItems: 'center',
    minHeight: 'auto'
  }
}

function Dropdown({
  defaultValue = '',
  values,
  title,
  name,
  id,
  displayEmpty = true
}) {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  return (
    <Box>
      <Typography className={classes.labelText}>{title}</Typography>
      <Select
        sx={selectMatchInputSx}
        id={id}
        name={name}
        defaultValue={defaultValue}
        displayEmpty={displayEmpty}
        className={globalClasses.input}>
        {values.map(item => {
          // Plain strings or { value, label } pairs
          const value = typeof item === 'string' ? item : item.value
          const label =
            typeof item === 'string' ? item.toUpperCase() : item.label
          return (
            <MenuItem value={value} key={value} style={{ color: 'black' }}>
              {label}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}

export default Dropdown
